import React from 'react';

export default () => (
  <svg height="38px" width="45px" version="1.1" viewBox="0 0 45 38">
    <g id="czechBased" fill="none" stroke="none" strokeWidth="1">
      <g id="Video-Copy-4" transform="translate(-795.000000, -2321.000000)">
        <g id="Footer" transform="translate(-5.000000, 2205.000000)">
          <g id="LookingFor-Copy" transform="translate(722.000000, 35.000000)">
            <g id="Comment" transform="translate(60.000000, 59.000000)">
              <rect height="80" id="Rectangle-path" width="80" x="0" y="0" />
              <rect height="80" id="Rectangle-path" width="80" x="0" y="0" />
              <path
                id="Shape"
                d="M53.9782609,29 L27.0217391,29 C25.9051634,29 25,29.9156413 25,31.0451421 L25,43.9977085 C25,45.1272093 25.9051634,46.0428506 27.0217391,46.0428506 L35.1086957,46.0428506 L39.5430435,50.5967003 C39.7961202,50.8548144 40.140619,51 40.5,51 C40.859381,51 41.2038798,50.8548144 41.4569565,50.5967003 L45.8913043,46.0428506 L53.9782609,46.0428506 C55.0948366,46.0428506 56,45.1272093 56,43.9977085 L56,31.0451421 C56,29.9156413 55.0948366,29 53.9782609,29 Z"
                fill="#FFC824"
              />
              <path
                id="Shape"
                d="M40,39 L40,37"
                stroke="#6B400D"
                strokeLinecap="round"
                strokeWidth="2"
              />
              <path
                id="Shape"
                d="M32,39 L32,37"
                stroke="#6B400D"
                strokeLinecap="round"
                strokeWidth="2"
              />
              <path
                id="Shape"
                d="M49,39 L49,37"
                stroke="#6B400D"
                strokeLinecap="round"
                strokeWidth="2"
              />
              <path
                id="Shape"
                d="M30.5,24 L30,24"
                stroke="#6B400D"
                strokeLinecap="round"
                strokeWidth="2"
              />
              <path
                id="Shape"
                d="M25.046875,23 L23.03125,23 C20.8048521,23 19,24.8129124 19,27.0492531 L19,47.9703942 C19,50.2067349 20.8048521,52.0196473 23.03125,52.0196473 L32.4375,52.0196473 L38.6053125,58.2150045 C39.6535382,59.2616652 41.3464618,59.2616652 42.3946875,58.2150045 L48.5625,52.0196473 L57.96875,52.0196473 C60.1951479,52.0196473 62,50.2067349 62,47.9703942 L62,27.0492531 C62,24.8129124 60.1951479,23 57.96875,23 L37.8125,23"
                stroke="#6B400D"
                strokeLinecap="round"
                strokeWidth="2"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
